import React, { useContext } from 'react';
import './PaymentMethod.css';
import { TranslationContext } from '../../../assets/contexts/translationContext';
import greenEn from '../../../assets/images/mainPbl/payment/greenEn.webp'
import greenBg from '../../../assets/images/mainPbl/payment/greenBg.webp'
import FirstEn from '../../../assets/images/mainPbl/payment/1En.webp'
import SecondEn from '../../../assets/images/mainPbl/payment/2En.webp'
import FirthdEn from '../../../assets/images/mainPbl/payment/3En.webp'

import FirstBg from '../../../assets/images/mainPbl/payment/1Bg.webp'
import SecondBg from '../../../assets/images/mainPbl/payment/2Bg.webp'
import FirthdBg from '../../../assets/images/mainPbl/payment/3Bg.webp'

import greenEnMobile from '../../../assets/images/mainPbl/payment/greenMobileEn.webp'
import greenBgMobile from '../../../assets/images/mainPbl/payment/greenMobileBg.webp'
import useWindowSize from '../../../assets/hooks/useWindowSize';

function PaymentMethod({ language }) {
    const { mainPbl } = useContext(TranslationContext);
    const { mainPaymentMethod } = mainPbl;
    const { width } = useWindowSize()

    const CARDS = [
        {
            en: FirstEn,
            bg: FirstBg
        },
        {
            en: SecondEn,
            bg: SecondBg
        },
        {
            en: FirthdEn,
            bg: FirthdBg
        },
    ]

    return (
        <div className='payment-method'>
            <p className='payment-method__title'>{mainPaymentMethod.title}</p>
            <p className='payment-method__subtitle'>{mainPaymentMethod.subtitle}</p>
            {width > 780 ?
                <img src={language === 'EN' ? greenEn : greenBg} alt='' className='payment-method__img_green'></img>
                :
                <img src={language === 'EN' ? greenEnMobile : greenBgMobile} alt='' className='payment-method__img_green'></img>
            }
            <div className='payment-method__cards-grid'>
                {CARDS.map((item, i) => {
                    return (
                        <img src={language === 'EN' ? item.en : item.bg} alt='' className='payment-method__card'></img>
                    )
                })}
            </div>
        </div>
    )
}
export default PaymentMethod